import uuid from 'react-uuid';
import React, { Fragment } from 'react';
import {
    USBIconCreditCard,
    USBIconMoneyBag,
    USBIconCheck,
    USBIconBranch,
    USBIconComputer,
    USBIconStoreFront,
} from '@usb-shield/react-icons';
import { firstQuestionPath } from '../constants';
import defaultLang from '../language';

const handleError = (e, fieldName) => {
    document.getElementsByName(fieldName)[0].focus();
};

export const productOrdering = (results) =>
    results.sort((a, b) => a.productOrder - b.productOrder);

const getFormData = (selector, activeQuestionID, answerList) => {
    if (typeof selector === 'string') {
        if (answerList?.[activeQuestionID]?.[selector]?.length > 0) {
            return answerList[activeQuestionID][selector];
        }
    }
    return false;
};

export const getElementAnswer = (
    answerContainer,
    activeQuestionID,
    questionId,
) => {
    const selectedActiveId = answerContainer[activeQuestionID];
    const selectedAnswer = [];
    if (selectedActiveId !== undefined) {
        [selectedActiveId]?.map((item) => {
            Object.keys(item).forEach((key) => {
                if (questionId && key === questionId.id) {
                    if (Array.isArray(item[key])) {
                        item[key].map((n) => {
                            if (n.value) {
                                selectedAnswer.push(n.value);
                            } else {
                                selectedAnswer.push(n);
                            }
                            return true;
                        });
                    }
                }
            });
            return true;
        });
    }
    return selectedAnswer;
};

const getErrorLink = (error, onClick, fieldProps, styles) => {
    const { fieldName, label } = fieldProps;
    let text;
    let link;
    const id = fieldProps.fieldName;
    const linkText = label;
    let textContent;
    if (Array.isArray(error)) {
        const [before, btn, after] = error;
        textContent =
            btn || (label && label.toLowerCase()) || fieldName;
        text = (
            <span className={styles['single-notification']}>
                <span
                    id={
                        styles[
                            `${fieldName}-single-notification--text-before`
                        ]
                    }
                >
                    {before}
                </span>
                <button
                    type="button"
                    id={
                        styles[
                            `${fieldName}-single-notification--link-btn`
                        ]
                    }
                    className={
                        styles['single-notification--link-btn']
                    }
                    onClick={(e) => onClick(e, fieldName)}
                    data-fieldname={fieldName}
                >
                    {textContent}
                </button>
                <span
                    id={
                        styles[
                            `${fieldName}-single-notification--text-after`
                        ]
                    }
                >
                    {after}
                </span>
            </span>
        );
    } else {
        text = error;
    }
    return { text, link, linkText, id };
};

export const getDefaultErrorInfo = (
    allQuestions,
    questionId,
    errorCode,
) => {
    const defaultError = allQuestions.filter(
        (item) => item.id === questionId,
    );
    const msg =
        errorCode === 225
            ? defaultError[0]?.metaData
                  ?.pageLevelNoneValidationMsgText
            : defaultError[0]?.metaData?.pageLevelValidationMsgText;

    return msg;
};

export const getFieldName = (allQuestions, questionId) => {
    const defaultError = allQuestions.filter(
        (item) => item.id === questionId,
    );
    return defaultError[0]?.metaData?.pageLevelValidationMsgLink.replace(
        '.',
        '',
    );
};

export const getFormErrors = (
    dynamicErrorCount,
    visibleQuestions,
    activeQuestionID,
    styles,
    allQuestions,
    answerList,
) => {
    const dynamicFieldUpdate = { ...dynamicErrorCount };
    const notifications = [];
    visibleQuestions.forEach((field) => {
        const selectedFormData = getFormData(
            field,
            activeQuestionID,
            answerList,
        );
        let errorInfo;
        let errorCode;
        let selectedValue = '';
        if (typeof selectedFormData === 'string') {
            selectedValue = selectedFormData;
        } else if (typeof selectedFormData === 'object') {
            selectedValue =
                selectedFormData?.[0]?.value ?? selectedFormData?.[0];
            errorCode =
                selectedFormData?.[0]?.errorCode ??
                selectedFormData[0];
        }
        if (!selectedValue) {
            errorInfo = getDefaultErrorInfo(
                allQuestions,
                field,
                errorCode,
            );
            dynamicFieldUpdate[field] += 1;
        } else if (selectedFormData[0]?.errorCode && field) {
            errorInfo = getDefaultErrorInfo(
                allQuestions,
                field,
                errorCode,
            );
        }
        if (errorInfo) {
            const notificationData = getErrorLink(
                errorInfo,
                handleError,
                {
                    label: getFieldName(allQuestions, field),
                    fieldName: field,
                },
                styles,
                errorCode,
            );
            notifications.push(notificationData);
        }
    });
    return [notifications, dynamicFieldUpdate];
};

export const dynamicQuestionValidation = (visibleQuestion) => {
    const questions = {};
    visibleQuestion.forEach((item) => {
        questions[item] = { inputValue: false };
    });
    return questions;
};

export const dynamicQuestionErrorCount = (visibleQuestion) => {
    const questions = {};
    visibleQuestion?.forEach((item) => {
        questions[item.id] = 0;
    });
    return questions;
};

export const getActiveID = (
    activeQuestionID,
    pageList,
    questionnaireState,
    nextbutton = false,
) => {
    const indexValue = pageList.indexOf(activeQuestionID);
    const currentPageid = nextbutton
        ? pageList[indexValue]
        : pageList[indexValue - 1];
    const list = questionnaireState.filter(
        (item) => item.id === currentPageid,
    );
    return {
        getPreviousPageIds: currentPageid,
        allVisibleId:
            list?.[0] && Object.keys(list?.[0]?.currentAnswer),
    };
};

export const getQuestionaire = (activeQuestionID, dataArchive) => {
    const questionList = dataArchive[activeQuestionID].data;
    const questions = questionList.startOver
        ? questionList.startOver
        : questionList.pullQuestionnaire;
    return questions.nextQuestionnaire;
};

export const getErrorMessage = (thisQuestion) => {
    const validationMsg = thisQuestion?.metaData?.validationMsg;
    const noneValidationMsg =
        thisQuestion?.metaData?.noneValidationMsg;
    const errorMessage = {
        radio: {
            224: validationMsg,
        },
        checkbox: {
            225: noneValidationMsg || '',
            224: validationMsg,
        },
        optionButton: { validationMsg },
    };
    return errorMessage[thisQuestion?.metaData?.questionType];
};

export const updateVisibleQuestionUtils = (
    inputValue,
    selectedFieldValLocal,
    nestedQuestionList,
    allQuestions,
    visibleQuestions,
    allValue,
    backButtonFlag,
) => {
    const localVisibleQuestions = visibleQuestions;
    const localAllValue = allValue;
    let localSelectedFieldValLocal = selectedFieldValLocal;
    if (backButtonFlag) {
        const selectedFieldKeys = Object.keys(
            localSelectedFieldValLocal,
        );
        Object.entries(localAllValue)
            .splice(1)
            .forEach(([key, value]) => {
                if (!selectedFieldKeys.includes(key)) {
                    localSelectedFieldValLocal = {
                        ...localSelectedFieldValLocal,
                        [key]: value[0]?.value,
                    };
                }
            });
    }
    // to check parent checkbox is selected or not and if it is unchecked then remove its value from selectedFieldValLocal
    // to manage visibility of elements
    Object.entries(localSelectedFieldValLocal).forEach(([key]) => {
        const selectedSubEleDetail = nestedQuestionList.filter(
            (inneritem) => inneritem.linkedQuestionId === key,
        )[0];
        if (typeof inputValue === 'object') {
            inputValue.forEach((item) => {
                if (!item.checked) {
                    nestedQuestionList.forEach((nitem) => {
                        if (item.valid === nitem.answerId) {
                            const id = visibleQuestions.indexOf(
                                nitem.linkedQuestionId,
                            );
                            if (
                                id > -1 &&
                                visibleQuestions.length !== 1
                            ) {
                                delete localAllValue[
                                    nitem.linkedQuestionId
                                ];
                                visibleQuestions.splice(id, 1);
                            }
                        }
                    });
                }
                // if element is not checked then remove it from object
                if (
                    selectedSubEleDetail &&
                    selectedSubEleDetail.answerId === item.valid &&
                    !item.checked
                ) {
                    allQuestions.forEach((allitem) => {
                        if (
                            allitem.id ===
                            selectedSubEleDetail.linkedQuestionId
                        ) {
                            allitem.answers.forEach((inneritem) => {
                                nestedQuestionList.forEach(
                                    (nitem) => {
                                        if (
                                            nitem.answerId ===
                                            inneritem.id
                                        ) {
                                            const linkedindex =
                                                localVisibleQuestions.indexOf(
                                                    nitem.linkedQuestionId,
                                                );
                                            if (
                                                localVisibleQuestions.length !==
                                                    1 &&
                                                linkedindex > -1
                                            ) {
                                                delete localAllValue[
                                                    nitem
                                                        .linkedQuestionId
                                                ];
                                                localVisibleQuestions.splice(
                                                    linkedindex,
                                                    1,
                                                );
                                            }
                                        }
                                    },
                                );
                            });
                        }
                    });
                    const linkedQIndex =
                        localVisibleQuestions.indexOf(
                            selectedSubEleDetail.linkedQuestionId,
                        );
                    if (
                        localVisibleQuestions.length !== 1 &&
                        linkedQIndex > -1
                    ) {
                        delete localAllValue[
                            selectedSubEleDetail.linkedQuestionId
                        ];
                        localVisibleQuestions.splice(linkedQIndex, 1);
                    }
                    delete localSelectedFieldValLocal[
                        selectedSubEleDetail.linkedQuestionId
                    ];
                }
            });
        } else {
            const currentElementID = Object.values(
                localSelectedFieldValLocal,
            ).indexOf(inputValue);
            const pid = Object.keys(localSelectedFieldValLocal)[
                currentElementID
            ];
            // checkbox is selected and sub menu is changing
            // to remove selection of sub menu (2nd level) if parent is different
            allQuestions.forEach((allitem) => {
                if (allitem.id === pid) {
                    allitem.answers.forEach((allans) => {
                        nestedQuestionList.forEach((nitem) => {
                            if (
                                nitem.answerId === allans.id &&
                                allans.id !== currentElementID
                            ) {
                                const visibleIndex =
                                    localVisibleQuestions.indexOf(
                                        nitem.linkedQuestionId,
                                    );
                                if (visibleIndex !== -1) {
                                    localVisibleQuestions.splice(
                                        visibleIndex,
                                        1,
                                    );
                                    delete localAllValue[
                                        nitem.linkedQuestionId
                                    ];
                                    delete localSelectedFieldValLocal[
                                        nitem.linkedQuestionId
                                    ];
                                }
                            }
                        });
                    });
                }
            });
        }
    });
};

export const buildVisibleQuestionList = (currentQuestionList) => {
    if (
        !currentQuestionList ||
        Object.keys(currentQuestionList).length === 0
    ) {
        return [];
    }
    const returnList = [];
    const cQLArray = Object.entries(currentQuestionList);
    cQLArray.forEach((eachCurrentQuestion) => {
        Object.keys(eachCurrentQuestion).forEach((key) => {
            if (Array.isArray(eachCurrentQuestion[key])) {
                eachCurrentQuestion[key].forEach((newItem) => {
                    if (newItem.value) {
                        returnList.push(newItem.value);
                    } else {
                        returnList.push(newItem);
                    }
                });
            }
            return false;
        });
    });
    return [...returnList] ?? [];
};

export const getProductIcons = (productGroup, size = 24) => {
    switch (productGroup) {
        case 'GTM':
        case 'Treasury management':
            return <USBIconBranch size={size} />;
        case 'OLB':
        case 'Digital banking':
            return <USBIconComputer size={size} />;
        case 'Pymt':
        case 'Pymt Sol':
        case 'Payment solutions':
            return <USBIconStoreFront size={size} />;
        case 'DDA':
        case 'Deposit':
            return <USBIconCheck size={size} />;
        case 'CCD':
        case 'Credit card':
            return <USBIconCreditCard size={size} />;
        case 'Capital':
        case 'Loan':
        case 'Lending':
            return <USBIconMoneyBag size={size} />;
        default:
            return '';
    }
};
// to sort chip title
export const chipOrdering = (counts) => {
    const sortedKeys = Object.keys(counts).sort();
    const sortedCounts = {};
    sortedKeys.forEach((key) => {
        sortedCounts[key] = counts[key];
    });
    return sortedCounts;
};
export const getFilterOptionList = ({ productList }) => {
    const categoryProduct = [];
    const counts = {};
    productList.map((item) => {
        categoryProduct.push(item.productCategory);
        return true;
    });
    categoryProduct.forEach((x) => {
        counts[x] = (counts[x] || 0) + 1;
    });
    const sortedCounts = chipOrdering(counts);
    const returnProduct = Object.entries(sortedCounts).map(
        (item) => ({
            label: (
                <Fragment key={`${item}_productname_chip`}>
                    {item[0]}
                    <span className="count-badge">{item[1]}</span>
                </Fragment>
            ),
            active: false,
            name: item[0],
        }),
    );
    return returnProduct;
};

export const getFilteredListOfProducts = (
    productList,
    filterList,
) => {
    const filteredItem = productList.filter((item) => {
        const filterProduct = filterList.find(
            (o) => o.name === item.productCategory && o.active,
        );
        if (filterProduct !== undefined) {
            if (item.productCategory === filterProduct.name) {
                return item;
            }
        }
        return false;
    });
    const productCategoryList =
        filteredItem.length > 0 ? filteredItem : productList;
    return productOrdering(productCategoryList);
};

export const createAnswerContainer = (questionId, ansCont) => {
    const localAnsContaine = ansCont;
    if (questionId.length === 1) {
        if (localAnsContaine[questionId[0]] === undefined) {
            localAnsContaine[questionId[0]] = {};
        }
        //  else {
        //     localAnsContaine[questionId[0]] = {};
        // }
    } else if (questionId.length > 1) {
        if (localAnsContaine[questionId[0]] === undefined) {
            const it = {};
            questionId.map((id) => {
                it[id] = {};
                return true;
            });
            localAnsContaine[questionId[0]] = it;
        } else {
            questionId.map((item) => {
                if (
                    localAnsContaine[questionId[0]][item] ===
                    undefined
                ) {
                    localAnsContaine[questionId[0]][item] = {};
                }
                return true;
            });
        }
    }
    return localAnsContaine;
};

export const getResult = (answers) => {
    const answersItem = [];
    if (typeof answers === 'object') {
        const inputElement = answers.inputValue;
        if (typeof inputElement === 'string') {
            if (inputElement !== '') {
                answersItem.push({
                    value: inputElement,
                    errorCode: answers.errorCode,
                });
            }
        } else {
            inputElement.forEach((item) => {
                if (item.checked === true) {
                    answersItem.push({
                        value: item.valid,
                        errorCode: answers.errorCode,
                    });
                }
            });
        }
    } else {
        answersItem.push(answers);
    }
    return answersItem;
};

export const getAnswers = (
    questionID,
    answerID,
    visibleQuestions,
    unsavedAnswerContainer,
) => {
    const newAnswer = JSON.parse(
        JSON.stringify(unsavedAnswerContainer),
    );
    if (newAnswer[visibleQuestions[0]] === undefined) {
        newAnswer[visibleQuestions[0]] = [];
        newAnswer[visibleQuestions[0]][questionID] =
            getResult(answerID);
    } else {
        newAnswer[visibleQuestions[0]][questionID] =
            getResult(answerID);
    }
    return newAnswer;
};
export const extraCommaRemover = (string) =>
    string.replace(/(^'|'$)/g, '');

export const linkGenerator = (string) => {
    // eslint-disable-next-line no-useless-escape
    const regex = /\<a href=(.*?) target=(.*?)\>(.*?)\<\/a\s*?\>|/;
    const learnMore = string?.match(regex);
    const href = extraCommaRemover(learnMore[1]);
    const target = extraCommaRemover(learnMore[2]);
    const text = extraCommaRemover(learnMore[3]);
    return { href, target, text };
};
export const sortByProductOrder = (list, allProducts = false) => {
    if (allProducts) {
        return list?.sort((a, b) =>
            a?.allProductOrder?.localeCompare(
                b?.allProductOrder,
                undefined,
                {
                    numeric: true,
                    sensitivity: 'base',
                },
            ),
        );
    }
    return list?.sort((a, b) => a?.productOrder - b?.productOrder);
};

export const checkAndSetCorrelationId = () => {
    if (!sessionStorage.getItem('correlationId')) {
        sessionStorage.setItem('correlationId', uuid());
    }
};

export const resetCorrelationId = () => {
    sessionStorage.removeItem('correlationId');
    // Set new correlation id
    checkAndSetCorrelationId();
};

export const groupProductsByCategory = (
    list,
    allProducts = false,
) => {
    const sortedList = sortByProductOrder(list, allProducts);
    const result = sortedList.reduce((r, a) => {
        const item = r;
        item[a.productCategory] = item[a.productCategory] || [];
        item[a.productCategory].push(a);
        return item;
    }, Object.create(null));
    return result;
};

export const getProductColor = (productGroup) => {
    const treasuryManagementColor = '#FDE0CC';
    const depositColor = '#F4E7CC';
    const digitalBankingColor = '#D5EAFF';
    const paymentSolutionsColor = '#FAD1D5';
    const creditCardColor = '#CCEEDD';
    const lendingColor = '#E0D1ED';

    switch (productGroup) {
        case 'GTM':
        case 'Treasury management':
            return treasuryManagementColor;
        case 'OLB':
        case 'Digital banking':
            return digitalBankingColor;
        case 'Pymt':
        case 'Pymt Sol':
        case 'Payment solutions':
            return paymentSolutionsColor;
        case 'DDA':
        case 'Deposit':
            return depositColor;
        case 'CCD':
        case 'Credit card':
            return creditCardColor;
        case 'Capital':
        case 'Loan':
        case 'Lending':
            return lendingColor;
        default:
            return '';
    }
};

const isObjectEmpty = (object) => {
    const isEmpty =
        Object.keys(object).length === 0 &&
        object.constructor === Object;
    return isEmpty;
};

function compactObject(data) {
    if (typeof data !== 'object') {
        return data;
    }
    return Object.keys(data).reduce((accumulator, key) => {
        const isObject = typeof data[key] === 'object';
        const value = isObject ? compactObject(data[key]) : data[key];
        const isEmptyObject = isObject && !Object.keys(value).length;
        if (value === undefined || isEmptyObject) {
            return accumulator;
        }

        return Object.assign(accumulator, { [key]: value });
    }, {});
}
export const getVisibleQuestions = (
    answerContainer,
    questionPath = firstQuestionPath,
) => {
    const answer = compactObject(answerContainer);
    const currentQuestion =
        answer && questionPath in answer
            ? answer[questionPath]
            : null;
    const visibleQuestions =
        currentQuestion && !isObjectEmpty(currentQuestion)
            ? Object.keys(currentQuestion)
            : [questionPath];

    return visibleQuestions;
};

export const filterInvalidQuestions = (questions) =>
    questions.filter((item) => item.questionId);

export const getCurrentPageTitleForReportingData = (
    activeQuestionID,
) => {
    const currentPagesMap = new Map([
        ['P1Q1', defaultLang.siteCat.goalsPage],
        ['P2Q1', defaultLang.siteCat.receivePayment],
        ['P3Q1', defaultLang.siteCat.makePayment],
        ['P4Q1', defaultLang.siteCat.manageBusiness],
    ]);
    return currentPagesMap.get(activeQuestionID);
};
